/**
  Organic Formula Custom Scripts
  By : Qadir Hassan

**/
// Link in Feeding chart 

// Link in Feeding chart 

(function () {
  function addFormulaCalculatorLink() {
    const table = document.querySelector(
      "#feeding-chart .accordion__content .expanded-content-old table"
    );

    if (!table) return;

    const container = table.parentElement;

    // Prevent duplicate buttons
    if (container.querySelector(".formula-calculator-link")) return;

    const link = document.createElement("a");

    link.href = "/pages/formula-calculator";
    link.textContent = "Formula Calculator";
    link.className = "formula-calculator-link";

    // Add the button immediately after the table
    table.insertAdjacentElement("afterend", link);
  }

  document.addEventListener("DOMContentLoaded", addFormulaCalculatorLink);

  // Shopify content may load after the initial page load
  setTimeout(addFormulaCalculatorLink, 500);
  setTimeout(addFormulaCalculatorLink, 1000);
  setTimeout(addFormulaCalculatorLink, 2000);
})();



// 
document.addEventListener("DOMContentLoaded", function () {
  const styleId = "hide-fc-card-when-results-active";

  function addHideStyle() {
    if (document.getElementById(styleId)) return;

    const style = document.createElement("style");
    style.id = styleId;
    style.textContent = `
      .template-product .shopify-section.fc-section .formula-calculator-section-product .fc-card {
        display: none !important;
      }
    `;

    document.head.appendChild(style);
  }

  function removeHideStyle() {
    const style = document.getElementById(styleId);
    if (style) style.remove();
  }

  function checkFcResults() {
    const fcResults = document.querySelector(
      ".template-product .shopify-section.fc-section .formula-calculator-section-product #fc-results"
    );

    if (fcResults && fcResults.classList.contains("on")) {
      addHideStyle();
    } else {
      removeHideStyle();
    }
  }

  checkFcResults();

  document.addEventListener("click", function () {
    setTimeout(checkFcResults, 100);
  });

  document.addEventListener("change", function () {
    setTimeout(checkFcResults, 100);
  });

  const target = document.querySelector(
    ".template-product .shopify-section.fc-section .formula-calculator-section-product"
  );

  if (target) {
    const observer = new MutationObserver(checkFcResults);

    observer.observe(target, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class", "style"]
    });
  }
});
// 

// Popup
document.addEventListener("DOMContentLoaded", function () {
  var popupSection = document.querySelector(
    ".template-product .shopify-section.fc-section"
  );

  var popupRoot = document.querySelector(
    ".template-product .shopify-section.fc-section .formula-calculator-section-product"
  );

  if (!popupSection || !popupRoot) return;

  function openPopup() {
    popupSection.classList.add("is-open");
    document.body.classList.add("fc-popup-open");
    updateResultState();
  }

  function closePopup() {
    popupSection.classList.remove("is-open");
    document.body.classList.remove("fc-popup-open");
  }

  function updateResultState() {
    var results = popupRoot.querySelector("#fc-results");

    if (results && results.classList.contains("on")) {
      popupRoot.classList.add("has-results");
    } else {
      popupRoot.classList.remove("has-results");
    }
  }

  function resetCalculator() {
    var resetBtn = popupRoot.querySelector(".fc-reset");
    var form = popupRoot.querySelector("form");
    var results = popupRoot.querySelector("#fc-results");

    // Use the calculator's existing reset functionality
    if (resetBtn) {
      resetBtn.click();
    } else if (form) {
      // Fallback in case the reset button is unavailable
      form.reset();
    }

    // Ensure the result state is cleared
    if (results) {
      results.classList.remove("on");
    }

    popupRoot.classList.remove("has-results");

    setTimeout(updateResultState, 150);
  }

  function resetAndClosePopup() {
    resetCalculator();
    closePopup();
  }

  document.addEventListener("click", function (event) {
    var calculatorLink = event.target.closest(".formula-calculator-link");

    if (calculatorLink) {
      event.preventDefault();
      openPopup();
      return;
    }

    // Close button inside results
    if (event.target.closest(".fc-res-hdr-close")) {
      event.preventDefault();
      resetAndClosePopup();
      return;
    }

    // Main popup close button
    if (event.target.closest(".closeButton")) {
      event.preventDefault();
      resetAndClosePopup();
      return;
    }

    if (event.target.closest("#fc-calc")) {
      setTimeout(updateResultState, 150);
      return;
    }

    if (event.target.closest(".fc-reset")) {
      setTimeout(updateResultState, 150);
    }
  });

  // Close by clicking outside the popup
  popupSection.addEventListener("click", function (event) {
    if (event.target === popupSection) {
      resetAndClosePopup();
    }
  });

  // Close using Escape key
  document.addEventListener("keydown", function (event) {
    if (
      event.key === "Escape" &&
      popupSection.classList.contains("is-open")
    ) {
      resetAndClosePopup();
    }
  });

  updateResultState();
});
// 

(function () {
  function addFormulaCalculatorLink() {
    const accordionContent = document.querySelector("#feeding-chart .accordion__content");

    if (!accordionContent) return;

    if (!accordionContent.querySelector(".formula-calculator-link")) {
      const link = document.createElement("a");

      link.href = "/pages/formula-calculator";
      link.textContent = "Formula Calculator";
      link.className = "formula-calculator-link";

      accordionContent.appendChild(link);
    }
  }

  document.addEventListener("DOMContentLoaded", addFormulaCalculatorLink);

  setTimeout(addFormulaCalculatorLink, 1000);
  setTimeout(addFormulaCalculatorLink, 2000);
})();

$(document).ready(function () {
  setTimeout(function () {
    const targetButton = document.querySelector('button[aria-controls="Footer-custom_dRK8UC"]');
    const targetContent = document.getElementById('Footer-custom_dRK8UC');

    if (targetButton && targetContent) {
      targetButton.classList.add('is-open');
      targetButton.setAttribute('aria-expanded', 'true');
      targetContent.classList.add('is-open');
    } else {
      console.log('Target button or content not found.');
    }
  }, 5000);
});

const heading = document.querySelector('.why-order-heading');
if (heading) {
  heading.innerHTML = heading.innerHTML.replace(
    /(Organic.*\?)/,
    '<strong>$1</strong>'
  );
}

document.addEventListener('click', function (e) {
  const trigger = e.target.closest('.collapsible-trigger');
  if (!trigger) return;

  // Only run the scroll-lock when the trigger is INSIDE the drawer
  const scrollable = trigger.closest('.drawer__scrollable');
  if (!scrollable) return;

  const savedScroll = scrollable.scrollTop;
  scrollable.style.scrollBehavior = 'auto';

  requestAnimationFrame(() => {
    scrollable.scrollTop = savedScroll;
    setTimeout(() => {
      scrollable.scrollTop = savedScroll;
      scrollable.style.scrollBehavior = '';
    }, 350);
  });
});


document.addEventListener("DOMContentLoaded", function () {
  const pages = [
    "/collections/shop-formula",
    "/pages/shipping",
    "/blogs/news",
    "/pages/faq",
    "/pages/contact",
    "/account",
    "/pages/about-us"
  ];

  const currentURL = window.location.href;

  pages.forEach(page => {
    if (currentURL.includes(page)) {
      const link = document.querySelector(`a[href*="${page}"]`);
      if (link) {
        let parent =
          link.closest(".mobile-nav__has-sublist") || link.closest(".mobile-nav__item");
        if (parent) {
          parent.classList.add("active");
        }
      }
    }
  });
});


// This function ensures the code runs only after the DOM is fully loaded.




document.addEventListener('DOMContentLoaded', function() {

  const targetButton = document.querySelector('button[aria-controls="Footer-custom_dRK8UC"]');

  if (targetButton) {
    
    targetButton.classList.add('is-open')

    const q = document.getElementById('Footer-custom_dRK8UC').classList.add('is-open')

  

  } else {
    console.log('Target button not found with aria-controls="Footer-custom_dRK8UC".');
  }


  
$('.why-order-section.why-organic-baby-formula .why-order-cards-wrappe').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 6,
  slidesToScroll: 2,
  responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
   
  ]
});


mobileOnlySlider(".why-order-section.why-organic-baby-formula .why-order-cards-wrapper-old", true, false, 769);

function mobileOnlySlider($slidername, $dots, $arrows, $breakpoint) {
    var slider = $($slidername);

    // Initial check on page load
    if ($(window).width() < $breakpoint) {
        slider.slick({
            mobileFirst: true,
            dots: $dots,
            arrows: $arrows,
            slidesToShow: 2,
            slidesToScroll: 1
        });
    }

    // Window resize handler
    $(window).on("resize", function () {
        if ($(window).width() < $breakpoint) {
            // Re-initialize if not already a slick slider
            if (!slider.hasClass("slick-initialized")) {
                slider.slick({
                    mobileFirst: true,
                    dots: $dots,
                    arrows: $arrows,
                    slidesToShow: 2,
                    slidesToScroll: 1
                });
            }
        } else {
            // Un-slick if it's currently a slick slider
            if (slider.hasClass("slick-initialized")) {
                slider.slick("unslick");
            }
        }
    });
}


// Add Menu Drawer text
  // function setDrawerTitle() {
  //   const drawerTitle = document.querySelector('.h2.drawer__title');
  //   if (drawerTitle && drawerTitle.textContent.trim() !== 'Menu') {
  //     drawerTitle.innerHTML = "<p>Menu</p>";
  //   }
  // }
  // setDrawerTitle();
  // setTimeout(setDrawerTitle, 500);
  // setTimeout(setDrawerTitle, 1500);


  // add class to the product tags like sold out, new etc 
  const statusElement = document.querySelectorAll('.grid-product__tag');
  for(let i=0;i<statusElement.length;i++){
    if(statusElement[i].textContent.includes('New')){
       statusElement[i].classList.add('new-arrival');
      
    }
  }

/* Home Page Product S;ider **/
mobileOnlySliderProducts(".home-featured .page-width .grid.grid--uniform", true, false, 769);
function mobileOnlySliderProducts($slidername, $dots, $arrows, $breakpoint) {
	var slider = $($slidername);
	var settings = {
		mobileFirst: true,
		dots: false,
    arrows: true,

    infinite:true,
    speed: 600,             
    cssEase: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)', 

    slidesToShow: 2,
		slidesToScroll: 1,

    swipe: true,
		swipeToSlide: true,
		touchMove: true,
		draggable: true,

		touchThreshold: 8,
		waitForAnimate: false,
    verticalSwiping: false,
     
    edgeFriction: 0.35,
    rows:1,
    adaptiveHeight: true,
    
        
		responsive: [
			{
				breakpoint: $breakpoint,
				settings: "unslick"

			}
		]
	};

	slider.slick(settings);

	$(window).on("resize", function () {
		if ($(window).width() > $breakpoint) {
			return;
		}
		if (!slider.hasClass("slick-initialized")) {
			return slider.slick(settings);
		}
	});
} // Mobile Only Slider

$('.home-featured .slick-list').on('touchstart', function(){
  $(this).css('cursor','grabbing');
});


// Change structure of single product page on Mobile
const singleMeta = document.querySelector('.product-single__meta .product-block.product-block--header');
// consloe.log('single meta',singleMeta)

 const elements = document.querySelectorAll('.home-featured .page-width .grid__item.medium-up--one-fifth');

   function removeClassOnMobile() {
    if (window.innerWidth <= 769) {
      elements.forEach(element => {
        element.classList.remove('medium-up--one-fifth');
      });
    } else {
      // Optional: Add the class back for larger screens
      elements.forEach(element => {
        element.classList.add('medium-up--one-fifth');
      });
    }
  }

  // Run the function on page load
  removeClassOnMobile();

  // Run the function on window resize
  window.addEventListener('resize', removeClassOnMobile);


/** Footer Colloaspe  */
// This script will work for screens between 768px and 1024px.
if (window.matchMedia('(min-width: 768px) and (max-width: 1024px)').matches) {
  // Select all the h4 elements with the specified classes.
  const buttons = document.querySelectorAll('h4.footer__title.collapsible-trigger.collapsible-trigger-btn.medium-up--hide.is-open');

  // Loop through each button and add a click event listener.
  buttons.forEach(button => {
    button.addEventListener('click', function() {
      // Find the next sibling element that has the class '.collapsible-content--small'.
      // This is the content you want to toggle.
      const content = this.nextElementSibling;
      
      // If the content exists, toggle the 'display-none' class on it.
      if (content && content.classList.contains('collapsible-content--small')) {
        content.classList.toggle('display-none');
      }
    });
  });
}

/* ======== Toggle SideBar Popup Functionality ============ */

// Helper function to manage cookies
function setCookie(name, value, days) {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
}

function getCookie(name) {
  const nameEQ = name + "=";
  const ca = document.cookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

// Function to open the popup
function openPopup(newsletterPopupElement) {
  if (!newsletterPopupElement) return;
  
  newsletterPopupElement.classList.add('is-active');
  document.body.classList.add('modal-open');
  document.body.classList.add('newsletter-modal-open');
  newsletterPopupElement.setAttribute('aria-expanded', 'true');
  
  // Focus on email input
  const emailInput = newsletterPopupElement.querySelector('input[type="email"]');
  if (emailInput) {
    emailInput.focus();
  }
}

// Function to close the popup
function closePopup(newsletterPopupElement) {
  if (!newsletterPopupElement) return;
  
  newsletterPopupElement.classList.remove('is-active');
  document.body.classList.remove('modal-open');
  document.body.classList.remove('newsletter-modal-open');
  newsletterPopupElement.setAttribute('aria-expanded', 'false');
}

const toggleButton = document.querySelector('.popup-toggle-btn');
const newsletterPopupElement = document.querySelector('.shopify-section-group-popup-group > div');

// Check if user has seen the popup before
const hasSeenPopup = getCookie('newsletter_popup_seen');

// Auto-open popup for new users after delay
if (!hasSeenPopup && newsletterPopupElement) {
  // Change delay time here (in milliseconds): 5000 = 5 seconds, 10000 = 10 seconds
  const delayTime = 5000; // 5 seconds
  
  setTimeout(() => {
    openPopup(newsletterPopupElement);
   document.body.classList.add('newsletter-modal-open');
    // Set cookie to remember user has seen the popup (expires in 30 days)
    setCookie('newsletter_popup_seen', 'true', 30);
  }, delayTime);
}

if (toggleButton) {
  toggleButton.addEventListener('click', function(event) {
    event.preventDefault();

    if (!newsletterPopupElement) {
      console.warn('Newsletter popup element not found. Make sure the section is rendered on the page and its ID is correct.');
      return;
    }

    // Toggle the popup
    const isActive = newsletterPopupElement.classList.contains('is-active');
    if (isActive) {
      closePopup(newsletterPopupElement);
    } else {
      openPopup(newsletterPopupElement);
    }
  });
} else {
  console.warn('Newsletter popup toggle button (.popup-toggle-btn) not found.');
}

// Handle close button
if (newsletterPopupElement) {
  const closeButton = newsletterPopupElement.querySelector('.js-modal-close');
  if (closeButton) {
    closeButton.addEventListener('click', function() {
      closePopup(newsletterPopupElement);
    });
  }

  // Close when clicking on overlay
  newsletterPopupElement.addEventListener('click', function(event) {
    if (event.target === newsletterPopupElement) {
      closePopup(newsletterPopupElement);
    }
  });

  
  const newsbtn = newsletterPopupElement.querySelector('.btn.newsletter-button .button--text');
   if (newsbtn) {
    newsbtn.addEventListener('click', function() {
      closePopup(newsletterPopupElement);
    });
  }
}



  // FAQ Toogle transitiuon
// FAQ Toggle transition

document.querySelectorAll('.custom-faq .collapsible-trigger').forEach(btn => {
  btn.addEventListener('click', () => {
    const isOpen = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', String(!isOpen));
  });
});




const parentContainer = document.querySelector('.site-footer .page-width .grid > div:nth-child(7) button');
if (parentContainer) {
  parentContainer.classList.remove('collapsible-trigger')
  parentContainer.classList.remove('collapsible-content')
  parentContainer.classList.remove('collapsible-content--small')
  parentContainer.classList.remove('is-open')
}


  // Main function ends here
});



/* Jquery Code */
$(document).ready(function () {
  $('.variant-input-wrap').each(function () {
    if ($(this).find('.variant-input').length === 4) {
      $(this).addClass('fourBox');
    }
  });

/* ========== Change the H2 Structure on Contact Page on Mobile ============ */
const mediaQuery = window.matchMedia('(max-width: 1024px)');
const headline = $('.page-contact-section-first .content-row h2');
const contentRow = $('.page-contact-section-first .content-row ');
const imageRow = $('.page-contact-section-first .image-row ');

function handleHeadlinePlacement(e) {
  if (e.matches) {
    // If screen is <= 1024px, move headline to image-row
    headline.prependTo(imageRow);
  } else {
    // If screen is > 1024px, move headline back to content-row
    headline.prependTo(contentRow);
  }
}

// 1. Run on initial load
handleHeadlinePlacement(mediaQuery);

// 2. Listen for changes
mediaQuery.addListener(handleHeadlinePlacement);


$('body').removeClass('klaviyo-prevent-body-scrolling')
$('.we-are-recommended-logo-box .text-column__grid a').attr('target','_blank');


// 1. Target the element to be clicked (the review count)

/* add shop formula link to hero btn */
$('.hero__text-wrap .hero__link a').attr('href','https://organicformulashop.com/collections/shop-formula')



 $('body.template-product #SiteHeader .mobile-logo').wrap("<a href='https://organicformulashop.com/'></a>");

 /* hide popup button when drawer menu opens*/
const drawer = document.getElementById('NavDrawer');
if (drawer) {
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.attributeName === 'class') {
        if($('#NavDrawer').hasClass('drawer--is-open')){
          $('.popup-toggle-btn').hide();
        } else {
          $('.popup-toggle-btn').show();
        }
      }
    });
  });

  observer.observe(drawer, { attributes: true });
}

 /* hide popup button when Mini Cart opens*/
const minidrawer = document.getElementById('CartDrawer');
if (minidrawer) {
  const miniobserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.attributeName === 'class') {
        if($('#CartDrawer').hasClass('drawer--is-open')){
          $('.popup-toggle-btn').hide();
        } else {
          $('.popup-toggle-btn').show();
        }
      }
    });
  });

  miniobserver.observe(minidrawer, { attributes: true });
}

/** Add a class when there is A Gift Card Image in Cart */

$('.template-cart .cart__page img[srcset*="giftcard.jpg"]').addClass('gift-card-img');
/* Add a class to body on SIngle product if is a giftcard */
// 1. Check for element existence using the corrected selector.
const selector = 'img.image-element[srcset*="giftcard.jpg"]';
    if ($(selector).length > 0) {
        // 2. Add the class to the body if the element is found.
$('body').addClass("gift-card-product"); } 

$('#CartDrawer .cart__image img[srcset*="giftcard.jpg"]').addClass('gift-card-img')


/* Add a unique class if there is only one item in mini cart*/
const cartItems = $('#CartDrawer .drawer__inner .drawer__scrollable .cart__item');

if (cartItems.length === 1) {$('#CartDrawer .drawer__inner .drawer__scrollable').addClass('mini-cart-single-item');} 

/** Remove fade animation on collection product images */
var $productImages = $('#CollectionAjaxContent .grid-product .image-wrap  image-element');

    // 🔨 Remove the unwanted attributes
    $productImages.removeAttr('data-aos');
    $productImages.removeAttr('data-aos-offset');

/* Add Target attribute in footer menu */
$('.site-footer a[href="https://organic-formula-shop.goaffpro.com/"]').attr('target', '_blank');

/* on Home page add okendo image in parent review page*/
// setTimeout(function() {
 
//     const newHtml = '<div class="okendo-img">' +
//                   '  <img src="https://cdn.shopify.com/s/files/1/0576/2547/7320/files/okedno-star.svg" alt="okendo star" />' +
//                   '</div>';
//     $('.template-index .oke-ratingsBadge .oke-minimalBadge').append(newHtml);
    
// }, 5000); // Adjust the delay (1000ms = 1s) as needed

/* on Home page add OkendoReviews logo in parent review badge */
(function () {
  const LOGO_URL = "https://cdn.shopify.com/s/files/1/0576/2547/7320/files/okedno-star.svg";

  if (!document.getElementById("okendo-star-styles")) {
    const style = document.createElement("style");
    style.id = "okendo-star-styles";
    style.textContent =
      ".template-index .oke-minimalBadge .okendo-img{display:inline-flex;align-items:center;margin-left:8px;}" +
      ".template-index .oke-minimalBadge .okendo-img img{height:18px;width:auto;display:block;}";
    document.head.appendChild(style);
  }

  function injectOkendoStar() {
    document
      .querySelectorAll(".template-index .oke-ratingsBadge .oke-minimalBadge")
      .forEach(function (badge) {
        if (badge.querySelector(".okendo-img")) return;
        const wrap = document.createElement("div");
        wrap.className = "okendo-img";
        wrap.innerHTML = '<img src="' + LOGO_URL + '" alt="Okendo Reviews" />';
        badge.appendChild(wrap);
      });
  }

  const okObserver = new MutationObserver(injectOkendoStar);
  okObserver.observe(document.body, { childList: true, subtree: true });

  injectOkendoStar();
  document.addEventListener("DOMContentLoaded", injectOkendoStar);
  window.addEventListener("load", injectOkendoStar);
})();



/* Jquery ends here*/
});



jQuery(document).ready(function ($) {
  function scrollToReviews() {
    var $reviewsAccordion = $("#reviews");
    // Check if reviews accordion is not already active
    if ($reviewsAccordion.hasClass("accordion-active") == false) {
      // Scroll to accordion section first
      $("html, body").animate(
        { scrollTop: $reviewsAccordion.offset().top - 100 },
        "slow"
      );
      // Trigger click on the reviews accordion title to open it
      $reviewsAccordion.find(".accordion__title").trigger("click");
    } else {
      // If already open, just scroll to it
      $("html, body").animate(
        { scrollTop: $reviewsAccordion.offset().top - 100 },
        "slow"
      );
    }
  }
  setTimeout(() => {
    $(".oke-sr-count").on("click", function () {
      console.log("clicked");
      scrollToReviews();
    });
  }, 700);

  $('.variant-input-wrap').each(function () {
    if ($(this).children('div').length > 3) {
      $(this).addClass('moreDiv');
    }
  });
});


// Auto-close filter sections when checkbox is selected
document.addEventListener('DOMContentLoaded', function() {
  // Use event delegation on the document to handle dynamically updated checkboxes
  document.addEventListener('change', function(e) {
    // Check if the changed element is a filter checkbox
    if (e.target.classList.contains('tag__input')) {
      // Find the closest collapsible-content container
      const collapsibleContent = e.target.closest('.collapsible-content');
      
      if (collapsibleContent && collapsibleContent.classList.contains('is-open')) {
        // Get the collapsible ID
        const collapsibleId = collapsibleContent.getAttribute('data-collapsible-id');
        
        // Find the trigger button using data-collapsible-id
        const triggerButton = document.querySelector(`[data-collapsible-id="${collapsibleId}"].collapsible-trigger`);
        
        if (triggerButton) {
          // Remove is-open class from button
          triggerButton.classList.remove('is-open');
          triggerButton.setAttribute('aria-expanded', 'false');
          
          // Remove is-open class from content and collapse it
          collapsibleContent.classList.remove('is-open');
          collapsibleContent.style.height = '0px';
        }
      }
    }
  }, true); // Use capture phase to ensure it catches the event
});


// Footer accordian 
/* ===== Footer accordion: keep only one section open (mobile) ===== */
(function () {
  var initialized = false;

  function initFooterAccordion() {
    if (initialized) return;

    var footer = document.querySelector('.site-footer');
    if (!footer) return;

    // var triggers = footer.querySelectorAll('.collapsible-trigger[aria-controls]');
    var triggers = Array.prototype.filter.call(
      footer.querySelectorAll('.collapsible-trigger[aria-controls]'),
      function (t) {
        return !t.closest('.drawer, #NavDrawer, [class*="mobile-nav"]');
      }
    );
    if (!triggers.length) return;

    var suppress = false;

    function isOpen(t) {
      return (
        t.classList.contains('is-open') ||
        t.getAttribute('aria-expanded') === 'true'
      );
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        if (suppress) return;

        setTimeout(function () {
          if (!isOpen(trigger)) return;

          suppress = true;
          triggers.forEach(function (other) {
            if (other !== trigger && isOpen(other)) {
              other.click();
            }
          });
          suppress = false;
        }, 50);
      });
    });

    initialized = true;
  }

  document.addEventListener('DOMContentLoaded', initFooterAccordion);
  window.addEventListener('load', initFooterAccordion);
})();

// Klaviyo form Show on home Only 

(function () {
  function toggleNeedsClick() {
    const isHome =
      document.body.classList.contains("template-index") ||
      window.location.pathname === "/";

    document.querySelectorAll(".needsclick.kl-teaser-STvYGk").forEach(function (el) {
      el.style.display = isHome ? "" : "none";
    });
  }

  document.addEventListener("DOMContentLoaded", toggleNeedsClick);
  window.addEventListener("load", toggleNeedsClick);

  const observer = new MutationObserver(toggleNeedsClick);

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();


/* Mobile nav: exclusive toggle for top-level sublists + keep parent open for children */
(function () {
  var TOP_TRIGGER = '.mobile-nav__has-sublist .mobile-nav__toggle .collapsible-trigger';

  // We track open state ourselves so the theme can't confuse us
  var openIds = {};

  function innerHeight(el) {
    var inner = el.querySelector('.collapsible-content__inner');
    return inner ? inner.scrollHeight : 0;
  }

  // Keep the <li> marked active, as the theme originally did
  function setItemActive(topLevel, active) {
    var item = topLevel.closest('.mobile-nav__item');
    if (!item) return;
    if (active) {
      item.classList.add('active-item');
    } else {
      item.classList.remove('active-item');
    }
  }

  function openSublist(topLevel, sublist) {
    sublist.classList.add('is-open');
    sublist.style.height = 'auto';
    topLevel.classList.add('is-open');
    topLevel.setAttribute('aria-expanded', 'true');
    setItemActive(topLevel, true);
    openIds[sublist.id] = true;
  }

  function closeSublist(topLevel, sublist) {
    sublist.classList.remove('is-open');
    sublist.style.height = '';
    topLevel.classList.remove('is-open');
    topLevel.setAttribute('aria-expanded', 'false');
    setItemActive(topLevel, false);
    openIds[sublist.id] = false;
  }

  // CAPTURE phase: run before the theme, and block all other handlers on this button
  document.addEventListener('click', function (e) {
    var topLevel = e.target.closest(TOP_TRIGGER);
    if (!topLevel) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    var id = topLevel.getAttribute('aria-controls');
    var sublist = id ? document.getElementById(id) : null;
    if (!sublist) return;

    if (sublist.classList.contains('is-open')) {
      closeSublist(topLevel, sublist);
    } else {
      openSublist(topLevel, sublist);
    }
  }, true);

  // CHILD submenu (Hipp/Holle/Kendamil): keep the parent list open
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.mobile-nav__child-item .collapsible-trigger');
    if (!trigger) return;

    var parent = trigger.closest('.mobile-nav__sublist.collapsible-content');
    if (!parent || !parent.id) return;

    // Use OUR tracked state, not aria-expanded (the theme mutates that)
    if (!openIds[parent.id]) return;

    var topLevel = document.querySelector(
      TOP_TRIGGER + '[aria-controls="' + parent.id + '"]'
    );

    function reassert() {
      parent.classList.add('is-open');
      parent.style.height = innerHeight(parent) + 'px';
      if (topLevel) {
        topLevel.classList.add('is-open');
        topLevel.setAttribute('aria-expanded', 'true');
        setItemActive(topLevel, true);
      }
    }

    reassert();
    setTimeout(reassert, 0);
    setTimeout(reassert, 60);
    setTimeout(reassert, 360);
  });
})();


/* Menu drawer title — isolated so no other script error can prevent it */
(function () {
  function setDrawerTitle() {
    var drawerTitle = document.querySelector('.h2.drawer__title');
    if (drawerTitle && drawerTitle.textContent.trim() !== 'Menu') {
      drawerTitle.innerHTML = "<p>Menu</p>";
    }
  }

  setDrawerTitle();
  document.addEventListener('DOMContentLoaded', setDrawerTitle);
  window.addEventListener('load', setDrawerTitle);
  setTimeout(setDrawerTitle, 300);
  setTimeout(setDrawerTitle, 1000);
  setTimeout(setDrawerTitle, 2500);

  // Also set it the moment the drawer is opened, in case it renders late
  document.addEventListener('click', function (e) {
    if (e.target.closest('.js-drawer-open-nav, .site-nav__link--icon, [data-drawer="NavDrawer"]')) {
      setTimeout(setDrawerTitle, 50);
      setTimeout(setDrawerTitle, 300);
    }
  });
})();
/* Klaviyo popup fix v3: after the popup is closed, Klaviyo's full screen dim layer stays in the page
   (opacity 0, pointer-events auto) and swallows every click. We check it a few times a second and, once the
   popup has been seen and then faded out, make that layer click-through and hidden for good.
   v2 blinked because it switched display back on (which restarts Klaviyo's fade-out). v3 never switches back
   and does not use display:none. */
;(function(){
  window.__oflKlFix = 'v3';
  setInterval(function(){
    var list = document.querySelectorAll('[data-kl-scroll-locking-modal]');
    for (var i = 0; i < list.length; i++){
      var el = list[i];
      if (el.__oflGone) continue;
      var o = parseFloat(getComputedStyle(el).opacity);
      if (o > 0.05){ el.__oflSeen = true; }
      else if (el.__oflSeen){
        el.__oflGone = true;
        el.style.setProperty('pointer-events', 'none', 'important');
        el.style.setProperty('visibility', 'hidden', 'important');
        var kids = el.querySelectorAll('*');
        for (var k = 0; k < kids.length; k++) kids[k].style.setProperty('pointer-events', 'none', 'important');
      }
    }
  }, 250);
})();